const translations = {
    account: 'Account',
    accountSubtitle: 'Your profile and roles',
    certifications: 'Certifications',
    certificationsSubtitle: 'Your state applicator pesticide certifications',
    details: 'Details',
    edit: 'Edit',
    email: 'Email',
    firstName: 'First Name',
    lastName: 'Last Name',
    myInformation: 'My Information',
    notProvided: 'Not provided',
    phone: 'Phone',
    roles: 'Roles'
};

export default translations;
